import React from 'react'
import ActivityTimeline from '@src/components/ActivityTimeline'

export default function ActivityFeed({ personalDetail }) {
  const items = personalDetail?.activity ?? []

  return (
    <div className="flex flex-col gap-[2px] rounded-xl border border-gray-200 bg-[#fdfdfd] shadow-sm">
      {/* Heading */}
      <div className="flex items-center justify-between pl-5 pr-5 pt-3 pb-2">
        <h3 className="text-sm font-semibold text-[#181d27]">Activity</h3>
      </div>

      {/* Timeline */}
      <div className="bg-white mx-[1px] mb-[1px] rounded-[12px] border border-[#e9eaeb] p-6 overflow-hidden h-full shadow-sm">
        <ActivityTimeline items={items} />
      </div>
    </div>
  )
}
